import { AxiosInstance } from "axios";
import { LoginDataResponse } from "./interfaces/LoginInterface";
import { LOGIN_PATH } from "../lib/path";
import BaseUseCase from "../lib/BaseUseCase";
import HartyValidator from "../common/utils/HartyValidator";

class LoginUseCase extends BaseUseCase {
  constructor(client: AxiosInstance) {
    super(client);
  }

  async login(username: string, password: string): Promise<LoginDataResponse> {
    try {
      HartyValidator.validateLoginData(username, password);

      const response = await this.client.post(LOGIN_PATH, {
        username: username,
        password: password,
      });

      sessionStorage.setItem("jwtToken", response.data.token);
      sessionStorage.setItem("username", response.data.user.firstName);
      sessionStorage.setItem("userId", response.data.user.id);

      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }
}

export default LoginUseCase;
